module.exports = __webpack_public_path__ + "img/Noctiluca-Process-2.aa7f7b51.png";